/**
 * A step Kuutio does not do in the UI yet, explained rather than hidden: what
 * it is, and the exact command (with a copy button) from the skill that owns
 * it. When a UI lands for the step, the hint is replaced, not the page.
 */
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Terminal, Copy, Check } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation.jsx';

const Box = styled.div`
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px dashed rgba(255, 255, 255, 0.15);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);

  .row { display: flex; align-items: center; gap: 8px; }
  code {
    flex: 1;
    min-width: 0;
    overflow-x: auto;
    white-space: nowrap;
    font-family: 'JetBrains Mono', ui-monospace, monospace;
    color: #e5e7eb;
  }
  button {
    display: inline-flex; align-items: center; gap: 4px;
    padding: 3px 8px; border-radius: 6px; border: 1px solid #333;
    background: transparent; color: #aaa; font-size: 11px; cursor: pointer;
  }
  small { display: block; margin-top: 4px; color: rgba(255, 255, 255, 0.45); }
`;

export default function ScriptHint({ command, skill }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch { /* clipboard blocked: the command is visible anyway */ }
  };
  return (
    <Box>
      <div className="row">
        <Terminal size={14} />
        <code>{command}</code>
        <button type="button" onClick={copy}>
          {copied ? <Check size={12} /> : <Copy size={12} />}
          {copied ? t('adminRunStrip.copied') : t('adminRunStrip.copy')}
        </button>
      </div>
      {skill && <small>{t('scriptHint.skill', { skill })}</small>}
    </Box>
  );
}
